import e, { extractVueListeners as t, removeClassStyleAttrs as n } from "../../common/utils/index.js";
import { t as r } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import i from "../button/button.js";
import a from "../tooltip/tooltip.js";
import { CALLBAR_BUTTON_VALID_WIDTH_SIZE as o } from "./callbar-button-constants.js";
import { createBlock as s, createElementVNode as c, createTextVNode as l, createVNode as u, mergeProps as d, normalizeClass as f, normalizeStyle as p, openBlock as m, renderSlot as h, resolveComponent as g, toDisplayString as _, toHandlers as v, withCtx as y } from "vue";
//#region recipes/buttons/callbar_button/callbar_button.vue
var b = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeCallbarButton",
	components: {
		DtButton: i,
		DtTooltip: a
	},
	inheritAttrs: !1,
	props: {
		id: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		active: {
			type: Boolean,
			default: !1
		},
		danger: {
			type: Boolean,
			default: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		circle: {
			type: Boolean,
			default: !1
		},
		ariaLabel: {
			type: String,
			default: null,
			validator: (e) => e || (void 0).$slots.default
		},
		buttonClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		textClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		buttonWidthSize: {
			type: String,
			default: "xl",
			validator: (e) => o.includes(e)
		},
		importance: {
			type: String,
			default: ""
		},
		invertedTooltip: {
			type: Boolean,
			default: !1
		},
		showTooltip: {
			type: Boolean,
			default: null
		},
		tooltipText: {
			type: String,
			default: void 0
		},
		tooltipDelay: {
			type: Boolean,
			default: void 0
		}
	},
	emits: ["click"],
	computed: {
		callbarButtonClass() {
			return [
				this.buttonClass,
				"d-recipe-callbar-button",
				{
					"d-recipe-callbar-button--circle": this.circle,
					"d-recipe-callbar-button--active": this.active,
					"d-recipe-callbar-button--danger": this.danger,
					"d-btn--disabled": this.disabled
				}
			];
		},
		callbarButtonTextClass() {
			return ["d-recipe-callbar-button__text", this.textClass];
		},
		buttonWidth() {
			switch (this.buttonWidthSize) {
				case "sm": return "4.5rem";
				case "md": return "6rem";
				default: return "8.4rem";
			}
		},
		buttonImportance() {
			return this.importance ? this.importance : this.circle ? "outlined" : "clear";
		},
		callbarButtonListeners() {
			return {
				...t(this.$attrs),
				click: (e) => this.$emit("click", e)
			};
		}
	},
	methods: { removeClassStyleAttrs: n }
};
function x(e, t, n, r, i, a) {
	let o = g("dt-button"), b = g("dt-tooltip");
	return m(), s(b, {
		id: n.id,
		inverted: n.invertedTooltip,
		class: f(e.$attrs.class),
		style: p(e.$attrs.style),
		delay: n.tooltipDelay,
		open: n.showTooltip,
		offset: [0, 24]
	}, {
		anchor: y(() => [c("span", { class: f({ "d-recipe-callbar-button--disabled": n.disabled }) }, [u(o, d({
			importance: a.buttonImportance,
			kind: "muted",
			"aria-disabled": n.disabled,
			"aria-label": n.ariaLabel,
			"label-class": a.callbarButtonTextClass,
			width: a.buttonWidth,
			class: a.callbarButtonClass
		}, a.removeClassStyleAttrs(e.$attrs), v(a.callbarButtonListeners)), {
			blockStartIcon: y(() => [e.$slots.blockStartIcon ? h(e.$slots, "blockStartIcon", { key: 0 }) : h(e.$slots, "icon", { key: 1 })]),
			default: y(() => [h(e.$slots, "default")]),
			_: 3
		}, 16, [
			"importance",
			"aria-disabled",
			"aria-label",
			"label-class",
			"width",
			"class"
		])], 2)]),
		default: y(() => [h(e.$slots, "tooltip", {}, () => [l(_(n.tooltipText), 1)])]),
		_: 3
	}, 8, [
		"id",
		"inverted",
		"class",
		"style",
		"delay",
		"open"
	]);
}
var S = /* @__PURE__ */ r(b, [["render", x]]);
//#endregion
export { S as default };

//# sourceMappingURL=callbar-button.js.map